// extracted by mini-css-extract-plugin
module.exports =  {"button":"_93444fe79c--button--OG_GQ","dark":"_93444fe79c--dark--sPwzU"};